import { RegionLookupService } from "./enums/RegionLookupServiceEnum.js";
import { UserRegion } from "./enums/UserRegionEnum.js";
import getUrl from "./getUrl";

export const getRegionByLookup = async (id, service) => {
  let serviceHost = getUrl();

  if (!serviceHost.includes("http")) {
    const protocol = window.location.protocol;

    serviceHost = `${protocol}//${serviceHost}`;
  }

  const serviceName = service ? service : RegionLookupService.BY_CONTENT;
  const serviceAttribute = "region";

  const url = `${serviceHost}/${serviceName}/${id}/${serviceAttribute}`;

  const { href } = window.location;
  let regionFound;

  // TODO this logic appears in more than one place. The best impl would be treat
  // "region" as a state (at index), then use this function to set a region value
  // and finally, use region for any other use cases.
  if (href.includes(UserRegion.CONOSUR.toLowerCase())) {
    regionFound = UserRegion.CONOSUR;
  } else if (href.includes(UserRegion.PACA.toLowerCase())) {
    regionFound = UserRegion.PACA;
  } else if (href.includes(UserRegion.MEXICO.toLowerCase())) {
    regionFound = UserRegion.MEXICO;
  } else {
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": "10bd6366-740f-4134-8372-40658ea1d91d",
      },
    };

    regionFound = await fetch(url, requestOptions)
      .then((response) => response.json())
      .then((response) => {
        return response.region;
      })
      .catch(() => {
        return UserRegion.BRASIL;
      });
  }

  return regionFound;
};

export default getRegionByLookup;



// WEBPACK FOOTER //
// ./src/helpers/getRegionByLookup.js